import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["spacing", "color", "checked"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from "react";
import { Switch as MuiSwitch } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import { jsx as _jsx } from "react/jsx-runtime";
var pxToRem = function pxToRem(px) {
  var oneRemPx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return "".concat(px / oneRemPx, "rem");
};
var switchStyles = function switchStyles(spacing, open) {
  var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RaiseColors.midnight;
  return makeStyles(function (theme) {
    var _context, _context2, _context3, _context4, _context5;
    var size = pxToRem(20);
    var width = pxToRem(40 + 2 * spacing);
    var borderWidth = 2;
    var height = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "calc(".concat(size, " + ")).call(_context2, borderWidth * 2, "px + ")).call(_context, pxToRem(2 * spacing), ")");
    return {
      root: {
        width: width,
        height: height,
        padding: pxToRem(spacing),
        margin: 0
      },
      switchBase: {
        padding: borderWidth,
        top: pxToRem(spacing),
        left: pxToRem(spacing),
        color: theme.palette.common.white,
        "&.Mui-checked": {
          transform: _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "translateX(calc(".concat(width, " - ")).call(_context5, size, " - ")).call(_context4, borderWidth * 2, "px - ")).call(_context3, pxToRem(2 * spacing), "))"),
          color: theme.palette.common.white
        },
        "&.Mui-checked + .MuiSwitch-track": {
          backgroundColor: color,
          color: color,
          opacity: 1,
          borderWidth: 0,
          border: "solid ".concat(RaiseColors.neutral400)
        }
      },
      thumb: {
        width: size,
        height: size,
        boxShadow: "0 3px 8px 0 rgba(0,0,0,0.15), 0 1px 1px 0 rgba(0,0,0,0.16), 0 3px 1px 0 rgba(0,0,0,0.1)"
      },
      track: {
        borderRadius: 40,
        border: "solid ".concat(RaiseColors.neutral400),
        borderWidth: borderWidth,
        backgroundColor: RaiseColors.neutral400,
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"])
      }
    };
  })();
};
var Switch = function Switch(_ref) {
  var _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 8 : _ref$spacing,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? RaiseColors.jllRed : _ref$color,
    checked = _ref.checked,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiSwitch, _objectSpread({
    checked: checked,
    classes: switchStyles(spacing, checked, color)
  }, props));
};
export default Switch;